import { useMutation } from '@apollo/client/react';

import {
  BundleBasketFragment,
  CardHolderInput,
  ProductType,
} from '@generated/gql/graphql';
import { BooleanSelection } from '@src/types/index';
import { YourDetailsFormValues } from '@src/types/yourDetails';
import { parseBirthdate } from '@utils/format';

import { updateCbcRequirements } from './query';

const getAccountHolders = (values: YourDetailsFormValues) => {
  const accountHolders: CardHolderInput[] = [];

  accountHolders.push({
    birthdate: parseBirthdate(values.aboutDoB),
    email: values.aboutEmail,
    firstName: values.aboutNameFirst,
    surname: values.aboutNameLast,
    title: values.aboutNameTitle,
    mobile: values.aboutContactNumber,
    main: true,
  });

  if (values.yaSecondCbcAccount === BooleanSelection.Yes) {
    const additionalHolder = {
      birthdate: parseBirthdate(values.yaSecondCbcDoB),
      email: values.yaSecondCbcEmail,
      firstName: values.yaSecondCbcNameFirst,
      surname: values.yaSecondCbcNameLast,
      title: values.yaSecondCbcNameTitle,
      mobile: values.yaSecondCbcContactNumber,
      main: false,
    };

    accountHolders.push(additionalHolder);
  }

  return accountHolders;
};

const useUpdateCbcRequirements = (productTypes: ProductType[]) => {
  const [updateRequirements] = useMutation(updateCbcRequirements);

  const updateCbcAccountHolders = (
    basket: BundleBasketFragment,
    values: YourDetailsFormValues
  ) => {
    if (!productTypes.includes(ProductType.CashbackCard)) {
      return;
    }

    const quote = basket.selectedQuotes.find(
      (quote) => quote.product.type === ProductType.CashbackCard
    );

    if (!quote) {
      // Should never happen
      throw new Error('updateCashbackCardQuoteRequirements: quote not found');
    }

    return updateRequirements({
      variables: {
        details: {
          basketId: basket.id,
          quoteId: quote.id,
          cardHolders: getAccountHolders(values),
          employeeNumber: '',
        },
      },
    });
  };

  return {
    updateCbcAccountHolders,
  };
};

export { useUpdateCbcRequirements };
